module.exports = __webpack_public_path__ + "images/sprites/ui/icon_award_7e5659361fa1d3fb5e71a0b1911b29c1.svg";